import React from "react";
import styled from "styled-components";

import {Box, Button, Heading, Stack, Text, TextLine} from "@unibuddy/patron";
import {IconArrowDown} from "@unibuddy/icons";

import useUniversityColor from "../../../../UniversityProvider/hooks/useUniversityColor";

type DescriptionSectionProps = {
    onViewStudentsClicked: () => void;
};

const StyledHeaderContent = styled.span`
    display: block;
    line-height: 2rem;
`;

const StyledHeadingUpper = styled(StyledHeaderContent)`
    font-weight: 700;
`;

const StyledHeadingLower = styled(StyledHeaderContent)`
    font-weight: 700;
    color: ${({theme}) => theme.colors.universityColor};
    margin-bottom: 12px;
`;

export function DescriptionSection({onViewStudentsClicked}: DescriptionSectionProps) {
    const universityColor = useUniversityColor();

    return (
        <Box>
            <Stack space="medium">
                <Heading level={2} size="large">
                    <StyledHeadingUpper>Talk to real students.</StyledHeadingUpper>
                    <StyledHeadingLower color={universityColor}>
                        Get real answers.
                    </StyledHeadingLower>
                </Heading>
                <Text color="grey600">
                    Get{" "}
                    <TextLine weight="700" color="inherit">
                        honest advice
                    </TextLine>{" "}
                    from those who’ve been in your shoes.
                </Text>

                <Button
                    round
                    color="university"
                    onClick={onViewStudentsClicked}
                    aria-label="View students"
                >
                    <Box display="flex" marginLeft="small" alignItems="center" width="100%">
                        View students
                    </Box>
                    <IconArrowDown />
                </Button>
            </Stack>
        </Box>
    );
}
